import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";

interface DialogInfoProps {
  testId?: string;
  onClose: () => void;
  isOpen: boolean;
  title: string;
  contentText: string;
  buttonText: string;
}

const useStyles = makeStyles(
  {
    dialog: {
      width: "420px",
      height: "204px",
      padding: "32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    titles: {
      fontSize: "20px",
      fontWeight: 700,
      textAlign: "center"
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "372px",
      height: "48px",
      marginTop: "30px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white",
      fontWeight: 400,
      lineHeight: "24px"
    },
    succcesType: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "5px"
    }
  },
  { name: "DialogInfo" }
);

const DialogConfirm = ({
  testId,
  isOpen,
  onClose,
  title,
  contentText,
  buttonText
}: DialogInfoProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
      data-testid={testId ?? "dialog-confirm"}
    >
      <Box className={classes.dialog} display="flex" flexDirection={"column"}>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>{title}</Typography>
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>
            {contentText}
            <br />
          </Typography>
        </div>

        <Button id="closeButton" className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>{buttonText}</Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogConfirm;
